import { render, staticRenderFns } from "./ProgressLoading.vue?vue&type=template&id=15261fa7&scoped=true"
var script = {}
import style0 from "./ProgressLoading.vue?vue&type=style&index=0&id=15261fa7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15261fa7",
  null
  
)

export default component.exports